import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthorizePolicies, AuthorizePolicy, PlatformState, PLATFORM_STATE_FEATURE_KEY } from './platform.state';

export const selectPlatformFeature = createFeatureSelector<PlatformState>(PLATFORM_STATE_FEATURE_KEY);

export const selectPortalSettings = createSelector(selectPlatformFeature, (state: PlatformState) => state.portalSettings);

export const selectPortalConfig = createSelector(selectPlatformFeature, (state: PlatformState) =>
  !!state.portalSettings.data ? state.portalSettings.data.portalConfig : null,
);

export const selectSystemInfo = createSelector(selectPlatformFeature, (state: PlatformState) => state.portalSettings.data?.systemInfo);

export const selectOidcConfig = createSelector(selectPlatformFeature, (state: PlatformState) =>
  !!state.portalSettings.data ? state.portalSettings.data.oidcConfig : null,
);

export const selectAbacusInstances = createSelector(selectPortalConfig, (config) => config?.abacusInstances || []);

export const selectAuthorizationPolicies = createSelector(selectPlatformFeature, (state: PlatformState) => {
  const map = new Map<AuthorizePolicies, AuthorizePolicy>();

  state.portalSettings.data?.authorizePolicies.reduce((acc, item) => {
    acc.set(item.name, item);
    return acc;
  }, map);

  return map;
});

export const selectIdentityClaims = createSelector(selectPlatformFeature, (state: PlatformState) => state.auth.identityClaims);

export const selectUser = createSelector(selectPlatformFeature, (state: PlatformState) => state.auth.user);

export const selectDialog = createSelector(selectPlatformFeature, (state: PlatformState) => state.dialog);

export const selectProgressBar = createSelector(selectPlatformFeature, (state: PlatformState) => state.progressBar);

export const selectLastRouterPath = createSelector(selectPlatformFeature, (state: PlatformState) => state.router.lastPath);
